import React, { Fragment, useEffect, useMemo, useRef, useState } from 'react'
import CorporateBasicInfo from './CorporateBasicInfo';
import CorporateAssignment from './CorporateAssignment';
import CorporateFinance from './CorporateFinance';
import CorporateAddOnInfo from './CorporateAddOnInfo';
import CorporateBusinessInfo from './CorporateBusinessInfo';
import { useLocation } from 'react-router-dom';
import { SaveConfirmModel } from '../../../customControl/SaveConfirmModel';
import { CorporateAgentAssignmentRef, isSavedTabForm, tabCollectionTravelCorporate, warningValidationTab } from '../../TravelAgentManagement/partial/TravelAgent.interface';
import { verifytoken } from '../../../services/ApiCallingUserServices';
import { ClearLocalStorage } from '../../../components/commonClass/Session';
import { useDispatch } from 'react-redux';
import { getuserprofileimagebyid } from '../../../components/commonClass/CommonFunctions';
import { AgentStatus } from '../../../_constants/agent.constant';

interface CreateCorporateProps {
    statusId?: number;
    isOnBording?: number;
    setCorporateStatusId?: any;
}

const CreateCorporate = ({ statusId, isOnBording: propIsOnBording, setCorporateStatusId: parentSetCorporateStatusId }: CreateCorporateProps) => {
    const location = useLocation();
    const dispatch = useDispatch();
    const [warningMessages, setWarningMessages] = useState<warningValidationTab[]>([])
    const [loginUserDomainMasterId, setLoginUserDomainMasterId] = useState(0); // 1 - Internal, 2 - TA (Travel Agent), 3 - Corporate
    const [isOnBording, setIsOnBording] = useState(0);

    useEffect(() => {
        if (propIsOnBording !== undefined) {
            setIsOnBording(propIsOnBording);
        }
    }, [propIsOnBording]);


    const corporateAgentAssignmentRef = useRef<CorporateAgentAssignmentRef>(null);

    const defaultTab: tabCollectionTravelCorporate = {
        id: 1,
        idName: "pills-Basic-Info-tab",
        name: "Basic Info",
        dataBsTarget: "#pills-Basic-Info",
        ariaControls: "pills-Basic-Info",
        ariaSelected: true,
        isSavedName: "BasicInfo",
    }
    const [selectedTab, setSelectedTab] = useState<tabCollectionTravelCorporate>(defaultTab);
    const [redirectTab, setRedirectTab] = useState<tabCollectionTravelCorporate>(defaultTab);
    const [isRedirect, setIsRedirect] = useState<boolean>(false);
    const [isConfirm, setIsConfirm] = useState<number>(0);
    const [isSaved, setIsSaved] = useState<isSavedTabForm>({
        BasicInfo: true,
        BusinessInfo: true,
        Assignment: true,
        Finance: true,
        AddOnInfo: true,
    })
    const [CorporateId, setCorporateId] = useState<number>(0);
    const [corporateStatusId, setCorporateStatusId] = useState<number | undefined>(statusId || location?.state?.statusId);

    const [modalShow, setModalShow] = useState<boolean>(false);

    const tabs: tabCollectionTravelCorporate[] = [
        {
            id: 1,
            idName: "pills-Basic-Info-tab",
            name: "Basic Info",
            dataBsTarget: "#pills-Basic-Info",
            ariaControls: "pills-Basic-Info",
            ariaSelected: true,
            isSavedName: "BasicInfo",
        },
        {
            id: 2,
            idName: "pills-Business-Info-tab",
            name: "Business Info",
            dataBsTarget: "#pills-Business-Info",
            ariaControls: "pills-Business-Info",
            ariaSelected: false,
            isSavedName: "BusinessInfo",
        },
        {
            id: 3,
            idName: "pills-Assignment-tab",
            name: "Assignment",
            dataBsTarget: "#pills-Assignment",
            ariaControls: "pills-Assignment",
            ariaSelected: false,
            isSavedName: "Assignment",
        },
        {
            id: 4,
            idName: "pills-Finance-tab",
            name: "Finance",
            dataBsTarget: "#pills-Finance",
            ariaControls: "pills-Finance",
            ariaSelected: false,
            isSavedName: "Finance",
        },
        {
            id: 5,
            idName: "pills-Add-on-info-tab",
            name: "Add-on Info",
            dataBsTarget: "#pills-Add-on-info",
            ariaControls: "pills-Add-on-info",
            ariaSelected: false,
            isSavedName: "AddOnInfo",
        },
    ]

    const handleTabChange = (ele: tabCollectionTravelCorporate) => {
        if (ele?.id !== selectedTab?.id) {
            setRedirectTab(ele)
            if (isSaved[selectedTab?.isSavedName]) {
                setSelectedTab(ele);
                setModalShow(false);
            }
            else {
                setModalShow(true);
            }
        }
    }

    useEffect(() => {
        if (isConfirm === 2) {
            setModalShow(false);
            setIsConfirm(0);
        }
    }, [isConfirm])

    useEffect(() => {
        if (isRedirect && redirectTab) {
            setSelectedTab(redirectTab);
            setIsRedirect(false);
        }
    }, [isRedirect, redirectTab])

    const getLoginUserDomianId = async () => {
        const userById = await getuserprofileimagebyid();
        if (userById?.status) {
            setLoginUserDomainMasterId(userById?.data?.[0]?.DomainMasterId)
        }
    }

    useEffect(() => {
        async function fetchData() {
            let statusoftoken = await verifytoken();
            if (statusoftoken) {
                const IsOnBoarding = location?.state?.itemData?.IsOnBoarding || 0;
                setIsOnBording(IsOnBoarding);
                Promise.allSettled([
                    getLoginUserDomianId(),
                ])
            }
            else {
                ClearLocalStorage();
                dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' })
            }
        }
        fetchData();
    }, [])

    //#region manage fields enable/disable depends on Domain or On board
    const domainWiseDisable = useMemo(() => {
        const effectiveStatusId = corporateStatusId;
        const isUneditableStatus = ([AgentStatus.Submit, AgentStatus.Approved] as number[]).includes(Number(effectiveStatusId));

        return {
            assignmentField: !(loginUserDomainMasterId === 1 && isOnBording === 1),
            isExternalUser: loginUserDomainMasterId !== 1 && (isOnBording === 1 ? isUneditableStatus : true),
            loginUserDomainMasterId: loginUserDomainMasterId,
            isOnBording: isOnBording
        }
    }, [loginUserDomainMasterId, isOnBording, corporateStatusId])
    //#endregion

    useEffect(() => {
        if (corporateStatusId !== undefined && parentSetCorporateStatusId) {
            parentSetCorporateStatusId(corporateStatusId);
        }
    }, [corporateStatusId, parentSetCorporateStatusId])



    return (
        <Fragment>
            <div className="m-2 heading_color">
                <h4>{selectedTab?.name}</h4>
            </div>
            <div className="m-2">
                <div className='container tab_section px-0'>
                    <ul className="nav nav-pills nav-justified mb-3 pt-3 col-12 " id="pills-tab" role="tablist">
                        {
                            tabs?.map((element) => {
                                return (
                                    <li
                                        key={element?.id}
                                        className="nav-item mt-1 mx-1"
                                        role="presentation"
                                        onClick={() => handleTabChange(element)}
                                    >
                                        <button className={`nav-link ${element?.id === selectedTab?.id && "active"}`}
                                            id={element?.idName}
                                            disabled={CorporateId > 0 ? false : true}
                                            // data-bs-toggle="pill"
                                            // data-bs-target={element?.dataBsTarget}
                                            type="button" role="tab"
                                            aria-controls={element?.ariaControls}
                                            aria-selected={element?.ariaSelected}>
                                            <div className="d-flex justify-content-center align-items-center ">
                                                <div className='fw-500'> {element?.name} </div>
                                                {
                                                    warningMessages?.map((obj: any) => {
                                                        return obj?.tabId === element?.id && <i className="mx-2 fa-solid fa-triangle-exclamation"></i>
                                                    })
                                                }
                                            </div>
                                        </button>
                                    </li>
                                )
                            })
                        }
                    </ul>
                </div>
                <div className="tab-content" id="pills-tabContent">
                    <div className={`tab-pane fade show ${selectedTab?.id === 1 && "active"}`} id="pills-Basic-Info" role="tabpanel" aria-labelledby="pills-Basic-Info-tab">
                        {
                            selectedTab?.id === 1 &&
                            <CorporateBasicInfo tabId={1}
                                selectedTabId={selectedTab?.id}
                                setIsSaved={setIsSaved}
                                isConfirm={isConfirm}
                                setIsConfirm={setIsConfirm}
                                setIsRedirect={setIsRedirect}
                                setCorporateId={setCorporateId}
                                CorporateId={CorporateId}
                                setWarningMessages={setWarningMessages}
                                domainWiseDisable={domainWiseDisable}
                                setCorporateStatusId={setCorporateStatusId}
                                datalist={location?.state?.datalist} />
                        }
                    </div>
                    <div className={`tab-pane fade show ${selectedTab?.id === 2 && "active"}`} id="pills-Operations-Info" role="tabpanel" aria-labelledby="pills-Operations-Info-tab">
                        {
                            selectedTab?.id === 2 &&
                            <CorporateBusinessInfo tabId={2} selectedTabId={selectedTab?.id} setIsSaved={setIsSaved} isConfirm={isConfirm} setIsConfirm={setIsConfirm} setIsRedirect={setIsRedirect} CorporateId={CorporateId} setWarningMessages={setWarningMessages} domainWiseDisable={domainWiseDisable} />
                        }
                    </div>
                    <div className={`tab-pane fade show ${selectedTab?.id === 3 && "active"}`} id="pills-Assignment" role="tabpanel" aria-labelledby="pills-Assignment-tab">
                        {
                            selectedTab?.id === 3 &&
                            <CorporateAssignment ref={corporateAgentAssignmentRef} tabId={3} selectedTabId={selectedTab?.id} isSaved={isSaved} setIsSaved={setIsSaved} isConfirm={isConfirm} setIsConfirm={setIsConfirm} setIsRedirect={setIsRedirect} CorporateId={CorporateId} warningMessages={warningMessages} setWarningMessages={setWarningMessages} domainWiseDisable={domainWiseDisable} />
                        }
                    </div>
                    <div className={`tab-pane fade show ${selectedTab?.id === 4 && "active"}`} id="pills-Finance" role="tabpanel" aria-labelledby="pills-Finance-tab">
                        {
                            selectedTab?.id === 4 &&
                            <CorporateFinance tabId={4} selectedTabId={selectedTab?.id} setIsSaved={setIsSaved} isConfirm={isConfirm} setIsConfirm={setIsConfirm} setIsRedirect={setIsRedirect} CorporateId={CorporateId} setWarningMessages={setWarningMessages} domainWiseDisable={domainWiseDisable} />
                        }
                    </div>
                    <div className={`tab-pane fade show ${selectedTab?.id === 5 && "active"}`} id="pills-Add-on-info" role="tabpanel" aria-labelledby="pills-Add-on-info-tab">
                        {
                            selectedTab?.id === 5 &&
                            <CorporateAddOnInfo tabId={5} selectedTabId={selectedTab?.id} setIsSaved={setIsSaved} isConfirm={isConfirm} setIsConfirm={setIsConfirm} setIsRedirect={setIsRedirect} CorporateId={CorporateId} warnings={{ Assignment: corporateAgentAssignmentRef?.current }} setWarningMessages={setWarningMessages} domainWiseDisable={domainWiseDisable} statusId={corporateStatusId} />
                        }
                    </div>
                </div>
            </div>
            <SaveConfirmModel
                show={modalShow}
                onHide={() => setModalShow(false)}
                yesconfirm={() => setIsConfirm(1)}
                noconfirm={() => { setModalShow(false); setSelectedTab(redirectTab); }}
                modletitle="Confirmation"
                message="There are unsaved data, do want to save first ?"
            />
        </Fragment >
    )
}


export default CreateCorporate